import { createContext } from 'react';

export interface AuthUser {
  id: number;
  username: string;
  email: string;
  fullName: string;
  roleCode: string;
  department: string | null;
  perms: Record<string, boolean>;
}

export interface AuthContextValue {
  user: AuthUser | null;
  loading: boolean;
  /** Resolves with the signed-in user. */
  login: (identifier: string, password: string) => Promise<AuthUser>;
  logout: () => Promise<void>;
  refreshMe: () => Promise<void>;
  hasPerm: (moduleId: string) => boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
